module.exports = __webpack_public_path__ + "static/img/img-mbti-random2.5fcdd25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-mbti-random2.jpg
// module id = Wck+
// module chunks = 156 157